import AccessLogs from "components/Collections/AccessLogs";
import Dashboard from "components/Collections/Dashboard";
import IpWhitelists from "components/Collections/IpWhitelists";
import Tokens from "components/Collections/Tokens";
import Users from "components/Collections/Users";
import Admins from "components/Collections/Admins";

const Collections = {
	AccessLogs: AccessLogs,
	Admins: Admins,
	Dashboard: Dashboard,
	IpWhitelists: IpWhitelists,
	Tokens: Tokens,
	Users: Users,

};

export default Collections;
